import "./SuperAdminEditProfile.scss";
import Spinner from "../../../components/Spinner/Spinner";
import Buttons from "../../../components/Buttons/Buttons";
import useSuperAdminEditProfile from "./useSuperAdminEditProfile";
import SuperAdminProfileHeader from "./SuperAdminProfileHeader";
import SuperAdminProfileFields from "./SuperAdminProfileFields";
import SuperAdminSecondaryEmails from "./SuperAdminSecondaryEmails";
import SuperAdminOtpModal from "./SuperAdminOtpModal";

const SuperAdminEditProfile = () => {
  const {
    errors,
    formData,
    secondaryEmails,
    newSecondaryEmail,
    setNewSecondaryEmail,
    editingIndex,
    editingEmail,
    setEditingEmail,
    isLoading,
    showOtpModal,
    otp,
    setOtp,
    handleChange,
    handleAddSecondaryEmail,
    handleDeleteSecondaryEmail,
    handleEditSecondaryEmail,
    handleSaveEditSecondaryEmail,
    handleCancelEditSecondaryEmail,
    isFormChanged,
    handleSubmit,
    handleVerifyOtp,
    handleCancelOtp,
    handleCancel,
  } = useSuperAdminEditProfile();

  return (
    <div className="main2">
      {isLoading && (
        <div className="loader-container">
          <div className="loader">
            <Spinner />
          </div>
        </div>
      )}
      <SuperAdminProfileHeader onBack={handleCancel} />
      <div className="main2_profileform">
        <div className="main2_profileform_container">
          <div className="main2_profileform_container_section">
            <SuperAdminProfileFields
              formData={formData}
              errors={errors}
              onChange={handleChange}
            />
            <SuperAdminSecondaryEmails
              secondaryEmails={secondaryEmails}
              newSecondaryEmail={newSecondaryEmail}
              onNewSecondaryEmailChange={setNewSecondaryEmail}
              onAddSecondaryEmail={handleAddSecondaryEmail}
              editingIndex={editingIndex}
              editingEmail={editingEmail}
              onEditingEmailChange={setEditingEmail}
              onEditSecondaryEmail={handleEditSecondaryEmail}
              onSaveEditSecondaryEmail={handleSaveEditSecondaryEmail}
              onCancelEditSecondaryEmail={handleCancelEditSecondaryEmail}
              onDeleteSecondaryEmail={handleDeleteSecondaryEmail}
            />
          </div>
        </div>

        <div className="main2_profileform_container_buttons">
          <div className="main2_profileform_container_buttons_cont">
            <div className="main2_profileform_container_buttons_cont_sec">
              <Buttons
                text="Cancel"
                type="button"
                onClick={handleCancel}
                className="cancel-button"
                variant="secondary"
                style={{ width: "100px" }}
              />
              <Buttons
                text="Save"
                type="button"
                onClick={handleSubmit}
                className="save-button"
                variant="primary"
                disabled={!isFormChanged()}
                style={{ width: "100px" }}
              />
            </div>
          </div>
        </div>

        <SuperAdminOtpModal
          open={showOtpModal}
          onCancel={handleCancelOtp}
          otp={otp}
          onOtpChange={setOtp}
          onVerify={handleVerifyOtp}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default SuperAdminEditProfile;
